import Button from 'react-bootstrap/Button';
import { Table } from 'react-bootstrap';
import Query from "../../common/Query";
import ListItem from './components/ProductListItem';
import PRODUCTS_QUERY from "./queries/PRODUCTS_QUERY";
import { useNavigate } from 'react-router-dom';

const ProductList = () => {
  const navigate = useNavigate();
  const listItems = () => <Query query={PRODUCTS_QUERY}>
    {({ data: { products } }: { data: { products: any[] } }) => {
      const list = products.map((product, i) =>
        <ListItem product={product} key={product.id} />
      );
      return <>
        <tbody>{list}</tbody>
        <Button className="my-4" onClick={() => navigate(`/admin/create-product/`)}>Add Product</Button>
      </>;
    }}
  </Query>;

  return <Table striped hover size="sm">
    <thead>
      <tr>
        <th>Code</th>
        <th>Title</th>
        <th>Last Edited</th>
        <th className="text-center">Delete</th>
        <th className="text-center">Edit</th>
      </tr>
    </thead>
    {listItems()}
  </Table>;
};

export default ProductList;